/**
 * ProductSelector – Picker reutilizável de produto para contexto IA.
 * Usado em CampaignBriefing, geradores de copy, flow builder, etc.
 */

import { trpc } from "@/lib/trpc";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Package } from "lucide-react";

interface ProductSelectorProps {
  value?: number;
  onChange: (id: number | undefined) => void;
  placeholder?: string;
  className?: string;
}

export default function ProductSelector({ value, onChange, placeholder, className }: ProductSelectorProps) {
  const { data: products = [] } = trpc.aiEmail.listProducts.useQuery();
  const activeProducts = products.filter(p => p.isActive);

  return (
    <Select
      value={value?.toString() ?? ""}
      onValueChange={v => onChange(v ? Number(v) : undefined)}
    >
      <SelectTrigger className={`${className ?? ""} w-full`}>
        <div className="flex items-center gap-2 min-w-0 flex-1">
          <Package className="w-3.5 h-3.5 text-muted-foreground shrink-0" />
          <span className="truncate flex-1 text-left">
            <SelectValue placeholder={placeholder ?? "Selecionar produto..."} />
          </span>
        </div>
      </SelectTrigger>
      <SelectContent>
        {activeProducts.length === 0 ? (
          <div className="p-2 text-xs text-muted-foreground text-center">
            Nenhum produto cadastrado
          </div>
        ) : (
          activeProducts.map(p => (
            <SelectItem key={p.id} value={p.id.toString()}>
              <div className="flex items-center gap-2">
                <span>{p.name}</span>
                {p.category && <span className="text-[10px] text-muted-foreground">({p.category})</span>}
              </div>
            </SelectItem>
          ))
        )}
      </SelectContent>
    </Select>
  );
}
